import { EVENT_PRICES } from '../config/paypal';

// Price for a single attendee of a given ticket type.
export function priceForType(type) {
  return type === 'member' ? EVENT_PRICES.member : EVENT_PRICES.nonMember;
}

/**
 * Total price for an event RSVP.
 *
 * @param {object} values - Formik values: { ticketType, guests: [{ type }] }
 * @param {boolean} fallbackIsMember - used only when values.ticketType is empty,
 *   to decide the primary attendee's default type (mirrors the previous inline logic).
 * @returns {number} total in dollars
 */
export function calculateEventTotal(values, fallbackIsMember = false) {
  const primaryType = values.ticketType || (fallbackIsMember ? 'member' : 'nonMember');
  const primary = priceForType(primaryType);
  const guestsTotal = (values.guests || []).reduce(
    (sum, g) => sum + priceForType(g.type || 'nonMember'),
    0
  );
  return primary + guestsTotal;
}
